<template>
  <nav class="flex items-center gap-2 text-sm" aria-label="Breadcrumb">
    <router-link
      to="/"
      class="text-surface-400 dark:text-surface-600 hover:text-accent-600 dark:hover:text-accent-400 transition-colors duration-200"
    >
      <HomeIcon class="h-4 w-4" />
    </router-link>

    <template v-for="(item, index) in items" :key="index">
      <ChevronRightIcon class="h-3.5 w-3.5 text-surface-300 dark:text-surface-700" />

      <router-link
        v-if="item.to && index < items.length - 1"
        :to="item.to"
        class="text-surface-400 dark:text-surface-500 hover:text-accent-600 dark:hover:text-accent-400 transition-colors duration-200"
      >
        {{ item.label }}
      </router-link>

      <span
        v-else
        class="text-surface-700 dark:text-surface-300 font-medium"
      >
        {{ item.label }}
      </span>
    </template>
  </nav>
</template>

<script setup>
import { HomeIcon, ChevronRightIcon } from '@heroicons/vue/24/outline'

defineProps({
  items: {
    type: Array,
    required: true,
  }
})
</script>
